let $backToTopBtn;
const offset = 10;
const toggleBackToTopButton = () => {
    if($('body').scrollTop() > offset || $('html').scrollTop() > offset) {
        $backToTopBtn.fadeIn();
    } else {
        $backToTopBtn.fadeOut();
    }
};

$(() => {
    $backToTopBtn = $('#backToTopBtn');
    toggleBackToTopButton();

    $(window).scroll(() => toggleBackToTopButton());

    $backToTopBtn.click(() => {
        $('html, body').animate({ scrollTop: 0 }, 'slow');
        return false;
    });
});
